import { render, staticRenderFns } from "./ed-autocomplete.vue?vue&type=template&id=322b4498&scoped=true&"
import script from "./ed-autocomplete.ts?vue&type=script&lang=ts&"
export * from "./ed-autocomplete.ts?vue&type=script&lang=ts&"
import style0 from "./ed-autocomplete.scss?vue&type=style&index=0&id=322b4498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322b4498",
  null
  
)

export default component.exports